export const NEW_MESSAGE = 'newMessage';
export const NOTIFICATION = 'socketNotification';
export const SEND_MESSAGE = 'sendMessage';
export const SEND_MESSAGE_SUCCEED = 'sendMessageSucceed';
export const SEND_MESSAGE_FAILED = 'sendMessageFailed';
